import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon as MuiSvgIcon } from '@mui/material';
import { styled } from '../muiReexports';
import { getIconSize } from './getIconSize';
export const SvgIconStyled = styled(({ color, ...props }) => _jsx(MuiSvgIcon, { ...props }), {
    shouldForwardProp: (prop) => prop !== 'disabled' && prop !== 'size' && prop !== 'color' && prop !== 'transition',
})(({ theme, size = 'md', color, disabled }) => ({
    height: getIconSize(size, theme.typography.pxToRem),
    width: getIconSize(size, theme.typography.pxToRem),
    color: disabled ? theme.palette.text.disabled : color,
}));
